<template>
  <div id="UserSubscriptionModal" class="content">
    <modal :show.sync="shouldShow" @hidden="onClickCancel" v-on:close="onClickCancel" footerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="modal-title">
        <b>유저 구독 부여</b>
      </h4>
      <div class="row">
        <div class="col-sm-6">
          <h4 class="card-title text-left">시작시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="시작시간">
                <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <h4 class="card-title text-left">종료시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="종료시간">
                <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="justify-content-center">
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickConfirm">확인</base-button>
        <base-button class="footer-buttons col-6" type="danger" round @click.native="onClickCancel">취소</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import { BaseInput, Modal } from "@/components/index";
import BaseButton from "@/components/BaseButton";

export default {
  name: "UserSubscriptionModal",
  components: {
    BaseButton,
    BaseInput,
    Modal,
  },
  data() {
    return {
      startTime: null,
      endTime: null,
    };
  },
  props: {
    userId: String,
    userIds: [],
    shouldShow: {
      type: Boolean,
      required: true,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onClickConfirm: async function () {
      await this.onConfirm();
      if (this.startTime === null || this.startTime === "") {
        window.Toast.error("시작시간을 넣어주세요");
        return;
      }
      if (this.endTime === null || this.endTime === "") {
        window.Toast.error("종료시간을 넣어주세요");
        return;
      }

      let userIds = [];
      if (this.userIds?.length > 0) {
        userIds = this.userIds;
      }
      if (this.userId !== null) {
        userIds.push(this.userId);
      }

      for (const userId of userIds) {
        await this.$axios.post(`/users/${userId}/subscription`, { startTime: this.startTime, endTime: this.endTime });
      }
      window.Toast.success("구독이 부여되었습니다");

      this.onClickCancel();
    },
    onClickCancel: async function () {
      await this.onCancel();
    },
  },
};
</script>
<style lang="scss">
#UserSubscriptionModal .modal-dialog {
  max-width: 600px !important;
}

.footer {
  .footer-buttons {
    width: 100px;
  }
}
</style>
